import { getStockSnapshot } from '@/components/sale/product-sale-utils';
import { ProductVariantRow } from '@/types/sale-type';
import { useMemo } from 'react';
import { useSalePins } from '../context/sale-providers';
import { useSaleProducts } from '../context/sale-providers';

export function useSaleFilteredRows(): ProductVariantRow[] {
  const { rows, search, onlyInStock } = useSaleProducts();
  const { activePinTab } = useSalePins();

  return useMemo(() => {
    let list = rows;
    if (activePinTab !== 'all') {
      list = list.filter(({ variantId }) => variantId === activePinTab);
    }
    if (search.trim()) {
      const trimmed = search.trim().toLowerCase();
      list = list.filter(({ p, v }) => {
        return (
          (p.code?.toLowerCase().includes(trimmed) ?? false) ||
          (p.name?.toLowerCase().includes(trimmed) ?? false) ||
          (v.sku?.toLowerCase().includes(trimmed) ?? false) ||
          (v.name?.toLowerCase().includes(trimmed) ?? false)
        );
      });
    }
    if (onlyInStock) {
      list = list.filter(({ p, v }) => getStockSnapshot(v, p).remain > 0);
    }
    return list;
  }, [rows, activePinTab, search, onlyInStock]);
}
